.question {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  padding: var(--tuna-spacing-3);
  background: var(--tuna-palette-background-paper);
  border-radius: 8px;
}

.header {
  display: flex;
  justify-content: flex-end;
}

.scoreChip {
  padding: var(--tuna-spacing-1) var(--tuna-spacing-2);
  border-radius: var(--tuna-shape-borderRadius);
  background: var(--tuna-palette-action-hover);
  color: var(--tuna-content-muted);
  font-size: var(--tuna-typography-caption-fontSize);
}

.prompt {
  margin: 0;
  font-size: var(--tuna-typography-h6-fontSize);
  color: var(--tuna-content-primary);
}

.actionRow {
  display: flex;
  gap: var(--tuna-spacing-2);
}

.answerRow {
  display: flex;
  gap: var(--tuna-spacing-2);
}
